console.log("💖 Qute & Quirky FAQ final smooth version loaded");

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".accordion__button, .faq dt button");
  if (!buttons.length) {
    console.warn("⚠️ No FAQ buttons found.");
    return;
  }

  // Remove old handlers
  buttons.forEach(btn => {
    const clone = btn.cloneNode(true);
    btn.parentNode.replaceChild(clone, btn);
  });

  const cleanButtons = document.querySelectorAll(".accordion__button, .faq dt button");

  cleanButtons.forEach(button => {
    const dt = button.closest("dt");
    const dd = dt ? dt.nextElementSibling : null;
    if (!dd) return;

    const plusIcon = button.querySelector(".icon--plus");
    const minusIcon = button.querySelector(".icon--minus");
    if (minusIcon) minusIcon.style.display = "none";

    button.setAttribute("aria-expanded", "false");
    dd.setAttribute("aria-hidden", "true");
    dd.style.height = "0px";
    dd.style.overflow = "hidden";
    dd.style.opacity = "0";
    dd.style.transition = "height 0.3s ease, opacity 0.25s ease";

    button.addEventListener("click", () => {
      const isOpen = button.getAttribute("aria-expanded") === "true";

      // Close others
      cleanButtons.forEach(b => {
        const d = b.closest("dt")?.nextElementSibling;
        if (d && d !== dd) {
          b.setAttribute("aria-expanded", "false");
          d.setAttribute("aria-hidden", "true");
          d.style.height = "0px";
          d.style.opacity = "0";
          const p = b.querySelector(".icon--plus");
          const m = b.querySelector(".icon--minus");
          if (p) p.style.display = "inline-block";
          if (m) m.style.display = "none";
        }
      });

      // Toggle current
      if (!isOpen) {
        button.setAttribute("aria-expanded", "true");
        dd.setAttribute("aria-hidden", "false");

        // Measure after small delay to ensure layout is ready
        dd.style.display = "block";
        dd.style.height = "auto";
        const targetHeight = dd.scrollHeight + 20; // buffer for padding
        dd.style.height = "0px";
        dd.style.opacity = "0";
        requestAnimationFrame(() => {
          dd.style.height = targetHeight + "px";
          dd.style.opacity = "1";
        });

        if (plusIcon) plusIcon.style.display = "none";
        if (minusIcon) minusIcon.style.display = "inline-block";

        // Cleanup inline height after transition
        dd.addEventListener(
          "transitionend",
          () => {
            if (button.getAttribute("aria-expanded") === "true") {
              dd.style.height = "auto";
            }
          },
          { once: true }
        );
      } else {
        button.setAttribute("aria-expanded", "false");
        dd.setAttribute("aria-hidden", "true");
        const currentHeight = dd.scrollHeight;
        dd.style.height = currentHeight + "px";
        dd.style.opacity = "1";
        requestAnimationFrame(() => {
          dd.style.height = "0px";
          dd.style.opacity = "0";
        });
        if (plusIcon) plusIcon.style.display = "inline-block";
        if (minusIcon) minusIcon.style.display = "none";
      }
    });
  });

  console.log("✅ Qute & Quirky FAQ accordion fully smooth and height-correct.");
});
